// src/components/layout/Navbar.jsx
import React, { useState } from 'react';
import { useTranslation } from '../../i18n';
import LanguageSelector from '../common/LanguageSelector';

const Navbar = () => {
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { href: '#mission', key: 'nav_mission' },
    { href: '#objectifs', key: 'nav_objectifs' },
    { href: '#presidence', key: 'nav_presidence' },
    { href: '#structure', key: 'nav_structure' },
    { href: '#galerie', key: 'nav_galerie' },
    { href: '#videos', key: 'nav_videos' },
    { href: '#adhesion', key: 'nav_adhesion' },
    { href: '#contact', key: 'nav_contact' },
  ];

  return (
    <>
      <div className="tricolor-flag" />
      
      <nav className="sticky top-0 z-50 bg-ofd-slate/95 backdrop-blur-sm shadow-lg border-b border-ofd-yellow/20">
        <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap px-4 md:px-10">
          <a href="#" className="flex items-center gap-3 py-3 no-underline group">
            <div className="relative">
              <img 
                src="/logo.jpeg"  // ✅ CORRIGÉ - sans /public/
                alt="Logo OFD - Organisation des Femmes pour le Développement"
                className="h-14 w-14 md:h-16 md:w-16 rounded-full object-cover border-2 border-ofd-yellow shadow-lg transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute -bottom-1 -right-1 flex gap-0.5 rounded-full overflow-hidden border-2 border-white shadow-md">
                <span className="w-2.5 h-2.5 bg-[#003F88]" />
                <span className="w-2.5 h-2.5 bg-[#F5C300]" />
                <span className="w-2.5 h-2.5 bg-[#C8102E]" />
              </div>
            </div>
            <div className="hidden sm:block">
              <span className="text-white text-sm font-semibold tracking-wide block">
                {t('nav_title')}
              </span>
              <span className="text-ofd-yellow text-[10px] font-medium tracking-widest uppercase flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-ofd-yellow inline-block" />
                Tchad
                <span className="w-1.5 h-1.5 rounded-full bg-ofd-yellow inline-block" />
              </span>
            </div>
          </a>

          <div className="flex items-center gap-5">
            <ul className="hidden md:flex gap-7 list-none">
              {navLinks.map((link) => (
                <li key={link.key}>
                  <a
                    href={link.href}
                    className="text-white/80 text-xs font-medium tracking-wide no-underline transition-all duration-200 hover:text-ofd-yellow hover:border-b-2 hover:border-ofd-yellow pb-1"
                  >
                    {t(link.key)}
                  </a>
                </li>
              ))}
            </ul>
            <LanguageSelector />

            <button
              className="md:hidden text-white/75 hover:text-ofd-yellow transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {isMobileMenuOpen && (
            <div className="w-full md:hidden py-4 border-t border-white/10">
              <ul className="flex flex-col gap-2 list-none">
                {navLinks.map((link) => (
                  <li key={link.key}>
                    <a
                      href={link.href}
                      className="text-white/80 text-sm font-medium no-underline transition-colors hover:text-ofd-yellow block py-2 px-3 rounded hover:bg-white/5"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {t(link.key)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;